import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DeviceType } from 'src/common/enumerations/device-type';
import { MessageModal } from '../../common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from '../../common/emerald-modal-manager/emerald-modal-manager';
import { IMessageModal } from '../../common/interfaces/dtos/IMessageModal';
import { AppState } from '../../common/redux/configure-store';

export const showAutoCloseMessageDialog = (props: AutoCloseMessageProps): void => {
  pushEmeraldModal(<AutoCloseMessagePopup {...props} />);
};

const AutoCloseMessagePopup: React.FC<AutoCloseMessageProps> = (
  props: AutoCloseMessageProps,
): JSX.Element => {
  const cashDrawerOpen = useSelector((store: AppState) => store.cashDrawer.open);
  const cashDrawerConnected = useSelector((store: AppState) =>
    store.deviceStatus.devices.find(i => i.deviceType === DeviceType.CashDrawer),
  );
  useEffect(() => {
    if (
      props.autoCloseWithCashRegister &&
      (!cashDrawerOpen || !(cashDrawerConnected && cashDrawerConnected.initialized))
    ) {
      popEmeraldModal();
    }
  }, [props.autoCloseWithCashRegister, cashDrawerOpen, cashDrawerConnected]);

  return <MessageModal {...props} />;
};

interface AutoCloseMessageProps extends IMessageModal {
  autoCloseWithCashRegister?: boolean;
}

export default AutoCloseMessagePopup;
